import { render, staticRenderFns } from "./DetailCourse.vue?vue&type=template&id=633c1059"
import script from "./DetailCourse.vue?vue&type=script&lang=js"
export * from "./DetailCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports